import { IState } from '../../store';

export function selectPromotions(state: IState) {
  return state.promotionsVillageData.promotions;
}
